export default "__VITE_ASSET__43a0834d__"